import { registerPlugin } from '@capacitor/core';

import type { InAppPurchasesPlugin } from './definitions';
import { CAPACITOR_IN_APP_PURCHASES_PLUGIN_NAME } from '../pluginConstants';

const InAppPurchases = registerPlugin<InAppPurchasesPlugin>(CAPACITOR_IN_APP_PURCHASES_PLUGIN_NAME);

export * from './definitions';
export { InAppPurchases };
